module.exports = __webpack_public_path__ + "static/media/timebomb-icon.e6941c9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/timebomb-icon.svg
// module id = 2879
// module chunks = 0